const validate = values => {
    const errors = {}
    const requiredFields = [
        'companyName',
        'bulstat',
        'managerName',
        'companyAddress',
        'contactPersonName',
        'contactPersonTitle',
        'contactAddress',
        'phone'
    ]

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'fieldRequired'
        }
    });

    return errors
}

export default validate

//const validate = values => {
//    const errors = {}
//    const requiredFields = [
//        'companyName',
//        'bulstat',
//        'managerName',
//        'companyAddress',
//        'contactPersonName',
//        'contactPersonTitle',
//        'contactAddress',
//        'phone'
//    ]

//    requiredFields.forEach(field => {
//        if (!values[field]) {
//            errors[field] = 'Полето е задължително'
//        }
//    });

//    return errors
//}

//export default validate